import { render, staticRenderFns } from "./ReportCallStats.vue?vue&type=template&id=537b5e74"
import script from "./ReportCallStats.vue?vue&type=script&lang=js"
export * from "./ReportCallStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports